import React from "react";

import OnlineSchool from "../assets/icons/online-learning.svg";
import Webinar from "../assets/icons/board.svg";
import Metting from "../assets/icons/metting.svg";

import SMS from "../assets/icons/mail.svg";
import Absence from "../assets/icons/web.svg";
import Register from "../assets/icons/document.svg";
import Report from "../assets/icons/report.svg";
import Finance from "../assets/icons/mobile.svg";
import Exam from "../assets/icons/book.svg";

// user comments:
import FARAJZADE from "../assets/images/comments/farajzade.jpeg";
import FARZAD from "../assets/images/comments/farzad.jpeg";
import JAFARI from "../assets/images/comments/jafari.jpeg";
import VAHID from "../assets/images/comments/vahid_tad.jpeg";
import NEZAM from "../assets/images/comments/nezam.jpeg";

import WOMAN from "../assets/images/comments/woman.jpeg";

// sustomers :
import CUSTOMER1 from "../assets/images/customers/logo_adiban.png";
import CUSTOMER2 from "../assets/images/customers/logo_alg.png";
import CUSTOMER3 from "../assets/images/customers/logo_azad.png";
import CUSTOMER4 from "../assets/images/customers/logo_farzane.png";
import CUSTOMER5 from "../assets/images/customers/logo_kooh.png";
import CUSTOMER6 from "../assets/images/customers/logo_otag.png";
import CUSTOMER7 from "../assets/images/customers/logo_park.png";
import CUSTOMER8 from "../assets/images/customers/logo_sbu.png";
import CUSTOMER9 from "../assets/images/customers/logo_shahed.png";

export const Banner50DataSource = {
  wrapper: { className: "home-page-wrapper banner5" },
  page: { className: "home-page banner5-page" },
  childWrapper: {
    className: "banner5-title-wrapper",
    children: [
      {
        name: "title",
        children: (
          <span>
            <p>آموزش بدون مرز</p>
          </span>
        ),
        className: "banner5-title",
      },
      {
        name: "explain",
        className: "banner5-explain",
        children: (
          <span>
            <p>پلتفرم آموزشی</p>
          </span>
        ),
      },
      {
        name: "content",
        className: "banner5-content",
        children: (
          <span>
            <p>
              مَدتاک می کوشد تا با ایجاد بستری آنلاین و هوشمند در عین سادگی و
              صرفه جویی در وقت و هزینه، تحولی شگرف در مدیریت مراکز آموزشی، و
              مدارس پدید آورد به این امید که در راه آموزش و ارتقای سطح علمی
              فرزندان این سرزمین همراه و یاور مدارس باشد.
            </p>
          </span>
        ),
      },
      // {
      //   name: "button",
      //   className: "banner5-button-wrapper",
      //   children: {
      //     href: "#",
      //     className: "banner5-button bold-btn",
      //     type: "primary",
      //     children: (
      //       <span>
      //         <p>همین حالا شروع کنید</p>
      //       </span>
      //     )
      //   }
      // }
    ],
  },
  image: {
    className: "banner5-image",
    children:
      "https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*-wAhRYnWQscAAAAAAAAAAABkARQnAQ",
  },
};
export const Content130DataSource = {
  OverPack: {
    className: "home-page-wrapper content13-wrapper khru5xc5hs-editor_css",
    playScale: 0.3,
    appear: true,
    always: false,
  },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      {
        name: "title",
        children: (
          <span>
            <span>
              <p>محصولات</p>
            </span>
          </span>
        ),
        className: "title-h1",
      },
    ],
  },
};
export const Feature40DataSource = {
  wrapper: {
    className: "home-page-wrapper content6-wrapper khrv1td154h-editor_css",
  },
  OverPack: {
    className: "home-page content6 khrurggcqd8-editor_css",
    always: false,
    playScale: [0.3, 0.3],
    gutter: 0,
  },
  textWrapper: { className: "content6-text", xs: 24, md: 10 },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      {
        name: "title",
        children: (
          <span>
            <p>سامانه برگزاری وبینار و کلاس آنلاین</p>
          </span>
        ),
        className: "title-h1",
      },
      {
        name: "content",
        className: "title-content",
        children: (
          <span>
            <p>
              «مدتاک»؛ دسترسی مطمئن وآسان به کلاس آنلاین و سیستم مدیریت آموزشی
            </p>
          </span>
        ),
      },
    ],
  },
  img: {
    children: "https://zos.alipayobjects.com/rmsportal/VHGOVdYyBwuyqCx.png",
    className: "content6-img",
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: "block0",
        img: {
          children: OnlineSchool,
          className: "content6-icon",
        },
        title: {
          className: "content6-title",
          children: (
            <span>
              <p>مدرسه آنلاین</p>
            </span>
          ),
        },
        content: {
          className: "content6-content",
          children: (
            <span>
              <span>
                <p>
                  به راحتی با دانش آموزان خود هر جایی که هستند، در ارتباط باشید
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: "block1",
        img: {
          className: "content6-icon",
          children: Webinar,
        },
        title: {
          className: "content6-title",
          children: (
            <span>
              <span>
                <p>وبینار</p>
              </span>
            </span>
          ),
        },
        content: {
          className: "content6-content",
          children: (
            <span>
              <p>
                افراد و مدرسین این امکان را دارند تا از طریق مدتاک سمینارهای خود
                را به صورت آنلاین برای صد ها نفر شرکت کننده برگزار کنند
              </p>
            </span>
          ),
        },
      },
      {
        name: "block2",
        img: {
          className: "content6-icon",
          children: Metting,
        },
        title: {
          className: "content6-title",
          children: (
            <span>
              <span>
                <p>جلسات آنلاین</p>
              </span>
            </span>
          ),
        },
        content: {
          className: "content6-content",
          children: (
            <span>
              <span>
                <p>
                  سازمان ها و شرکت ها میتوانند با استفاده از امکانات داناپلاس
                  جلسات خود را با بالاترین کیفیت به صورت آنلاین برگزار کنند
                </p>
              </span>
            </span>
          ),
        },
      },
    ],
  },
};
export const Feature20DataSource = {
  wrapper: { className: "home-page-wrapper content2-wrapper" },
  OverPack: {
    className: "home-page content2 khrv7h6dq69-editor_css",
    playScale: 0.3,
    always: false,
  },
  imgWrapper: { className: "content2-img", md: 10, xs: 24 },
  img: {
    children: "https://zos.alipayobjects.com/rmsportal/tvQTfCupGUFKSfQ.png",
  },
  textWrapper: { className: "content2-text", md: 14, xs: 24 },
  title: {
    className: "content2-title",
    children: (
      <span>
        <p>نرم افزار مدیریت مدارس</p>
      </span>
    ),
  },
  content: {
    className: "content2-content",
    children: (
      <span>
        <p>
          ما در مدتاک تلاش کرده ایم که هر آنچه مدیران، معلمان، دانش آموزان و
          اولیای آنها برای پیش برد اهداف خود در حوزه آموزش نیاز دارند را در یک
          اپلیکیشن جامع با سطوح دسترسی مختلف ارائه کنیم.
        </p>
      </span>
    ),
  },
};
export const Feature30DataSource = {
  wrapper: { className: "home-page-wrapper content3-wrapper" },
  page: { className: "home-page content3" },
  OverPack: { playScale: 0.3, always: false },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      {
        name: "title",
        children: (
          <span>
            <p>امکانات اصلی نرم افزار مدیریت مدارس</p>
          </span>
        ),
        className: "title-h1",
      },
      {
        name: "content",
        className: "title-content",
        children: "",
      },
    ],
  },
  block: {
    className: "content3-block-wrapper",
    children: [
      /**   {
        name: "block0",
        className: "content3-block",
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children: SMS,
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: (
              <span>
                <span>
                  <span>
                    <p>پنل پیامکی</p>
                  </span>
                </span>
              </span>
            )
          },
          content: {
            className: "content3-content",
            children: "امکانی برای ارسال پیام های انبوه برای اولیا، دانش آموزان و معلمین"
          }
        }
      },
      */
      {
        name: "block1",
        className: "content3-block",
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children: Absence,
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: (
              <span>
                <span>
                  <p>حضور و غیاب</p>
                </span>
              </span>
            ),
          },
          content: {
            className: "content3-content",
            children:
              "حضور و غیاب هوشمند کلاسی و امکان گزارش گیری و اطلاع رسانی",
          },
        },
      },
      {
        name: "block2",
        className: "content3-block",
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children: Register,
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: (
              <span>
                <span>
                  <p>مدیریت ثبت نام</p>
                </span>
              </span>
            ),
          },
          content: {
            className: "content3-content",
            children:
              "امکان پیش ثبت نام دانش آموزان، بارگذاری مدارک مورد نیاز و همچنین پرداخت آنلاین",
          },
        },
      },
      {
        name: "block3",
        className: "content3-block",
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children: Report,
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: (
              <span>
                <p>گزارش گیری</p>
              </span>
            ),
          },
          content: {
            className: "content3-content",
            children: "امکان مشاهده و گزارش گیری از عملکرد دانش آموزان ",
          },
        },
      },
      {
        name: "block4",
        className: "content3-block",
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children: Finance,
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: (
              <span>
                <p>پنل مالی</p>
              </span>
            ),
          },
          content: {
            className: "content3-content",
            children:
              "امکانی برای پرداخت آنلاین شهریه ها و هزینه های مورد نیاز مدرسه",
          },
        },
      },
      {
        name: "block5",
        className: "content3-block",
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children: Exam,
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: (
              <span>
                <span>
                  <span>
                    <p>آزمون آنلاین</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: "content3-content",
            children:
              "راهکاری برای برگزاری امن و آنلاین آزمون ها همراه با امکان تصحیح و انتشار نمره",
          },
        },
      },
    ],
  },
};
export const Content131DataSource = {
  OverPack: {
    className: "home-page-wrapper content13-wrapper khrvd1hqtqe-editor_css",
    playScale: 0.3,
    always: false,
    appear: true,
  },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      {
        name: "image",
        children:
          "https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg",
        className: "title-image",
      },
      {
        name: "title",
        children: (
          <span>
            <p>نظرات کاربران</p>
          </span>
        ),
        className: "title-h1",
      },
    ],
  },
};
export const Teams00DataSource = {
  wrapper: { className: "home-page-wrapper teams0-wrapper" },
  OverPack: { playScale: 0.3, className: "home-page teams0", always: false },
  BannerAnim: {
    className: "banner-anim",
    children: [
      {
        name: "elem0",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: FARAJZADE,
              className: "teams0-image",
            },
            {
              name: "content",
              children:
                "در دومین سال استفاده از سامانه مدتاک میتوانیم به جرئت بگوییم مدتاک بی نظیر و بی نقص است ",
              className: "teams0-content",
            },
            {
              name: "title",
              children: "محمدرضا فرجزاده",
              className: "teams0-h1",
            },
            {
              name: "content2",
              children: "مدیر مدرسه ادیبان",
              className: "teams0-content",
            },
          ],
        },
      },
      {
        name: "elem1",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: JAFARI,
              className: "teams0-image",
            },
            {
              name: "content",
              children:
                " امیدواریم که مدتاک همیشه دوست دانش آموزان ما در سال های بعدی باشد",
              className: "teams0-content",
            },
            {
              name: "title",
              children: "فرج اله جعفری",
              className: "teams0-h1",
            },
            {
              name: "content2",
              children: "مدیر مدرسه سروش",
              className: "teams0-content",
            },
          ],
        },
      },
      {
        name: "elem2",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: WOMAN,
              className: "teams0-image",
            },
            {
              name: "content",
              children:
                " پشتیبانی عالی و کیفیت بالا از ویژگی های بارز مدتاک است",
              className: "teams0-content",
            },
            { name: "title", children: "خانم رستمی", className: "teams0-h1" },
            {
              name: "content2",
              children: "مدیر مدرسه اندیشمندان فرزانه",
              className: "teams0-content",
            },
          ],
        },
      },
      {
        name: "elem2",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: WOMAN,
              className: "teams0-image",
            },
            {
              name: "content",
              children: "مدتاک در مقایسه با رقبا یک سرو گردن بالاتر است",
              className: "teams0-content",
            },
            { name: "title", children: "خانم معصومی", className: "teams0-h1" },
            {
              name: "content2",
              children: "مدیر مدرسه کوهستانی",
              className: "teams0-content",
            },
          ],
        },
      },
      {
        name: "elem2",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: VAHID,
              className: "teams0-image",
            },
            {
              name: "content",
              children:
                " پاسخ‌دهی و پشتیبانی حرفه‌ای مدتاک حس امنیتی به ما داد که با خیال راحت گزینه هوشمندی با مدتاک رو انتخاب کنیم.",
              className: "teams0-content",
            },
            {
              name: "title",
              children: "وحید تدین نیا",
              className: "teams0-h1",
            },
            {
              name: "content2",
              children: "کارشناس فناوری دانشگاه",
              className: "teams0-content",
            },
          ],
        },
      },
      {
        name: "elem2",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: FARZAD,
              className: "teams0-image",
            },
            {
              name: "content",
              children:
                "خوشبختانه مدتاک همیشه در دسترس هست و هیچ قطعی و از دسترس خارج شدنی در این سامانه دیده نشد.",
              className: "teams0-content",
            },
            {
              name: "title",
              children: "فزراد شایان مهر",
              className: "teams0-h1",
            },
            {
              name: "content2",
              children: "مدیر فنی اتاق بازرگانی",
              className: "teams0-content",
            },
          ],
        },
      },
      {
        name: "elem2",
        className: "teams0-banner-user-elem",
        titleWrapper: {
          className: "teams0-content-wrapper",
          children: [
            {
              name: "image",
              children: NEZAM,
              className: "teams0-image",
            },
            {
              name: "content",
              children:
                "پلتفرم برگزاری جلسات آنلاین مدتاک با کیفیت بالا و امکانات مناسبش به خوبی پاسخ گویی نیاز های ما هست.",
              className: "teams0-content",
            },
            {
              name: "title",
              children: "آقای نظام آبادی",
              className: "teams0-h1",
            },
            {
              name: "content2",
              children: "تحلیلگر فارکس",
              className: "teams0-content",
            },
          ],
        },
      },
    ],
  },
};
export const Content120DataSource = {
  wrapper: { className: "home-page-wrapper content12-wrapper" },
  page: { className: "home-page content12 khrs4ytsx8c-editor_css" },
  OverPack: { playScale: 0.3, className: "" },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      {
        name: "image",
        children:
          "https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg",
        className: "title-image",
      },
      {
        name: "title",
        children: (
          <span>
            <span>
              <p>مشتریان ما</p>
            </span>
          </span>
        ),
        className: "title-h1",
      },
    ],
  },
  block: {
    className: "img-wrapper",
    children: [
      {
        name: "block0",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER1,
          },
        },
      },
      {
        name: "block1",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER2,
          },
        },
      },
      {
        name: "block2",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER3,
          },
        },
      },
      {
        name: "block3",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER4,
          },
        },
      },
      {
        name: "block4",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER5,
          },
        },
      },
      {
        name: "block6",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER6,
          },
        },
      },
      {
        name: "block7",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER7,
          },
        },
      },
      {
        name: "block8",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER8,
          },
        },
      },
      {
        name: "block9",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "block-content" },
          img: {
            children: CUSTOMER9,
          },
        },
      },
    ],
  },
};
